import dompurify from 'dompurify';
import { useMembers } from '~/common/composables/members.js';

const { getUserDetails } = useMembers();

const color_set = ['#FE8A52', '#43C678', '#FE6363', '#5B607E', '#07A192'];

function stringToNumber(string) {
  let total = 0;
  for (const char of string)
    total += char.charCodeAt(0);

  return color_set[total % color_set.length];
}

export function exportUsersData(users) {
  const { members_details } = getUserDetails(users);
  return members_details?.map(user => getUserData(user)?.label).join(', ');
}

function getUserData(user) {
  const display_name = user.name;

  return ({
    bg_color: stringToNumber(user?.name),
    label: dompurify.sanitize(display_name.trim(), { ALLOWED_TAGS: [] }),
    id: user.uid,
    avatar: user?.display_picture ?? '',
    email: dompurify.sanitize(user?.email, { ALLOWED_TAGS: [] }),
  });
}

export function memberRender(instance, td, row, col, prop, value) {
  td.innerHTML = '';
  td.className = `htCenter htMiddle`;
  const { members_details } = getUserDetails(value);
  members_details?.forEach((user) => {
    if (user) {
      const user_details = getUserData(user);

      const container = document.createElement('div');
      container.style.display = 'flex';
      container.classList = `gap-1`;
      container.style.alignItems = 'center';
      if (user_details.avatar) {
        const img = document.createElement('img');
        img.src = user?.display_picture ?? '';
        img.className = `rounded-full object-cover`;
        img.style.width = '24px';
        img.style.height = '24px';
        container.appendChild(img);
      }
      else {
        const span = document.createElement('span');
        span.className = `flex items-center justify-center rounded-full`;
        span.style.width = '24px';
        span.style.height = '24px';
        span.style.backgroundColor = user_details?.bg_color;
        span.textContent = user_details.label?.substring(0, 1);
        span.style.color = 'white';
        span.style.alignContent = 'center';
        container.appendChild(span);
      }
      const name = document.createElement('span');
      name.textContent = user_details.label;

      container.appendChild(name);
      td.appendChild(container);
    }
  });
  return td;
}
